import React, { useCallback, useState } from 'react';
import { Navbar, NavDropdown, Nav, Container } from 'react-bootstrap';
import { graphql, useStaticQuery } from 'gatsby';
import { useCookies } from 'react-cookie';
import Button from '../Button/Button';
import Logo from '../../assets/Logo.svg';
import LogoWhite from '../../assets/Logo2.svg';
import TextLink from '../TextLink/TextLink';

function CustomNavbar({ colorScheme, additionalClasses = [] }) {
    const [isOpen, setIsOpen] = useState(false);
    const [visible, setVisible] = React.useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [cookies] = useCookies(['logged']);
    const data = useStaticQuery(query);

    const handleMouseEnter = useCallback((dropdownType) => {
        if (window.innerWidth > 992) {
            setDropdownOpen(dropdownType);
        }
    }, []);

    const handleMouseLeave = useCallback(
        (dropdownType) => {
            if (window.innerWidth > 992 && dropdownOpen === dropdownType) {
                setDropdownOpen(null);
            }
        },
        [dropdownOpen]
    );

    const handleClick = useCallback(
        (dropdownType) => {
            if (window.innerWidth <= 992) {
                setDropdownOpen(
                    dropdownOpen === dropdownType ? null : dropdownType
                );
            }
        },
        [dropdownOpen]
    );

    const onFeaturesMouseLeave = useCallback((e) => {
        if (
            !e.relatedTarget ||
            (!e.relatedTarget.closest('.features-tab-dropdown-menu') &&
                !e.relatedTarget.closest('.nav-link__features-dropdown'))
        ) {
            setVisible(false);
        }
    }, []);

    return (
        <Navbar
            collapseOnSelect
            variant={colorScheme}
            expand="lg"
            sticky="top"
            id="navbar"
            className={[isOpen ? 'open' : '', ...additionalClasses].join(' ')}
        >
            {visible && (
                <div className="backdrop" onClick={() => setVisible(false)} />
            )}
            <Container fluid className="position-relative">
                {visible && (
                    <div
                        className="features-tab-dropdown-menu d-none d-lg-block custom-features-nav-dropdown"
                        onMouseEnter={() => setVisible(true)}
                        onMouseLeave={onFeaturesMouseLeave}
                    >
                        <div className="row">
                            <div className="col-6 col-xl-4">
                                {data.allFeatures.nodes.map((feature, index) =>
                                    index < 5 ? (
                                        <TextLink
                                            href={`/features/?feature=${index}`}
                                            className="dropdown-item"
                                            key={feature.id}
                                            data-event-category="Page navbar events"
                                            data-event-label={feature.name}
                                            dataEventLocation="nav_top_feature_item"
                                        >
                                            <span className="dropdown-item__icon">
                                                <img
                                                    src={
                                                        feature.menu_icon[0]
                                                            .localFile.publicURL
                                                    }
                                                    alt={feature.name}
                                                />
                                            </span>
                                            {feature.name}
                                        </TextLink>
                                    ) : null
                                )}
                            </div>
                            <div className="col-6 col-xl-4">
                                {data.allFeatures.nodes.map((feature, index) =>
                                    index > 4 && index < 10 ? (
                                        <TextLink
                                            href={`/features/?feature=${index}`}
                                            className="dropdown-item"
                                            key={feature.id}
                                            data-event-category="Page navbar events"
                                            data-event-label={feature.name}
                                            dataEventLocation="nav_top_feature_item"
                                        >
                                            <span className="dropdown-item__icon">
                                                <img
                                                    src={
                                                        feature.menu_icon[0]
                                                            .localFile.publicURL
                                                    }
                                                    alt={feature.name}
                                                />
                                            </span>
                                            {feature.name}
                                        </TextLink>
                                    ) : null
                                )}
                                <div className="dropdown-item__see-all-features d-flex d-xl-none">
                                    <TextLink
                                        href="/features/"
                                        className="link-with-arrow"
                                        data-event-category="Page navbar events"
                                        dataEventLocation="nav_top_feature_item"
                                    >
                                        See all features
                                    </TextLink>
                                </div>
                            </div>
                            <div className="col-6 col-xl-4 d-none d-xl-block">
                                {data.allFeatures.nodes.map((feature, index) =>
                                    index > 9 ? (
                                        <TextLink
                                            href={`/features/?feature=${index}`}
                                            className="dropdown-item"
                                            key={feature.id}
                                            data-event-category="Page navbar events"
                                            data-event-label={feature.name}
                                            dataEventLocation="nav_top_feature_item"
                                        >
                                            <span className="dropdown-item__icon">
                                                <img
                                                    src={
                                                        feature.menu_icon[0]
                                                            .localFile.publicURL
                                                    }
                                                    alt={feature.name}
                                                />
                                            </span>
                                            {feature.name}
                                        </TextLink>
                                    ) : null
                                )}
                                <div className="dropdown-item__see-all-features">
                                    <TextLink
                                        href="/features/"
                                        className="link-with-arrow"
                                        data-event-category="Page navbar events"
                                        dataEventLocation="nav_top_feature_item"
                                    >
                                        See all features
                                    </TextLink>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <Navbar.Brand
                    href="/"
                    data-event-tracking
                    data-event-type="click"
                    data-event-category="Page events"
                    data-event-label="Navbar logo"
                    data-event-location="nav_top_logo"
                >
                    <img
                        className="flotiq-logo flotiq-logo--light-theme"
                        src={Logo}
                        width={138}
                        height={36}
                        alt="Flotiq"
                    />
                    <img
                        className="flotiq-logo flotiq-logo--dark-theme"
                        src={LogoWhite}
                        width={138}
                        height={36}
                        alt="Flotiq"
                    />
                </Navbar.Brand>
                <div className="mobile-header-right">
                    <Nav className="d-sm-inline d-lg-none">
                        <Button
                            click={() =>
                                window.open(
                                    `${process.env.GATSBY_FLOTIQ_DASHBOARD_URL}/register?plan=1ef44daa-fdc3-6790-960e-cb20a0848bfa`,
                                    '_self'
                                )
                            }
                            dataEventLabel="Get Flotiq"
                        >
                            <Nav.Item>Get Flotiq</Nav.Item>
                        </Button>
                    </Nav>
                    <Navbar.Toggle
                        aria-controls="responsive-navbar-nav"
                        onClick={() => setIsOpen(!isOpen)}
                    />
                </div>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto pb-4 pb-lg-0">
                        <Nav.Item
                            role="button"
                            className="dropdown-toggle nav-link nav-link__features-dropdown d-none d-lg-block"
                            onMouseEnter={() => setVisible(true)}
                            onMouseLeave={onFeaturesMouseLeave}
                        >
                            {visible ? (
                                <span className="nav-link__opened">
                                    Features
                                </span>
                            ) : (
                                <span className="nav-link__closed">
                                    Features
                                </span>
                            )}
                        </Nav.Item>
                        <NavDropdown
                            title="Features"
                            id="basic-nav-dropdown"
                            className=" d-block d-lg-none"
                        >
                            {data.allFeatures.nodes.map((feature, index) => (
                                <TextLink
                                    href={`/features/?feature=${index}`}
                                    className="dropdown-item pl-2 pl-lg-0 text-wrap"
                                    key={feature.id}
                                    data-event-category="Page navbar events"
                                    dataEventLocation="nav_top_feature_item"
                                >
                                    {feature.name}
                                </TextLink>
                            ))}
                            <TextLink
                                href="/features/"
                                className="dropdown-item dropdown-item--see-all-features link-with-arrow mt-3 mb-3"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_feature_item"
                            >
                                See all features
                            </TextLink>
                        </NavDropdown>
                        <NavDropdown
                            className="custom-nav-dropdown"
                            title="Solutions"
                            id="basic-nav-dropdown"
                            onMouseEnter={() => handleMouseEnter('solutions')}
                            onMouseLeave={() => handleMouseLeave('solutions')}
                            onClick={() => handleClick('solutions')}
                            show={dropdownOpen === 'solutions'}
                        >
                            <TextLink
                                href="/solutions/mobile-apps"
                                className="dropdown-item pl-2 pl-lg-4"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_solutions_item"
                            >
                                Mobile Apps
                            </TextLink>
                            <TextLink
                                href="/solutions/intranet"
                                className="dropdown-item pl-2 pl-lg-4"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_solutions_item"
                            >
                                Intranet
                            </TextLink>
                            <TextLink
                                href="/solutions/websites"
                                className="dropdown-item pl-2 pl-lg-4"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_solutions_item"
                            >
                                Websites
                            </TextLink>
                        </NavDropdown>
                        <Nav.Link
                            href="/pricing/"
                            onClick={() => {
                                setIsOpen(false);
                                setVisible(false);
                            }}
                            data-event-tracking
                            data-event-type="click"
                            data-event-category="Page navbar events"
                            data-event-label="Pricing"
                            data-event-location="nav_top_pricing"
                        >
                            Pricing
                        </Nav.Link>
                        <NavDropdown
                            className="custom-nav-dropdown"
                            title="Resources"
                            id="basic-nav-dropdown"
                            onMouseEnter={() => handleMouseEnter('resources')}
                            onMouseLeave={() => handleMouseLeave('resources')}
                            onClick={() => handleClick('resources')}
                            show={dropdownOpen === 'resources'}
                        >
                            <TextLink
                                href="https://blog.flotiq.com/"
                                className="dropdown-item pl-2 pl-lg-4"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_resources_item"
                            >
                                Blog
                            </TextLink>
                            <TextLink
                                href="/case-studies/"
                                className="dropdown-item pl-2 pl-lg-4"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_resources_item"
                            >
                                Case studies
                            </TextLink>
                            <TextLink
                                href="https://flotiq.com/docs/"
                                className="dropdown-item pl-2 pl-lg-4"
                                target="_blank"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_resources_item"
                            >
                                Docs
                            </TextLink>
                            <TextLink
                                href="https://flotiq.com/docs/faq/"
                                className="dropdown-item pl-2 pl-lg-4"
                                target="_blank"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_resources_item"
                            >
                                FAQ
                            </TextLink>
                            <TextLink
                                href="/starters/"
                                className="dropdown-item pl-2 pl-lg-4"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_resources_item"
                            >
                                Starters
                            </TextLink>
                            <TextLink
                                href="/integrations/"
                                className="dropdown-item pl-2 pl-lg-4"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_resources_item"
                            >
                                Integrations
                            </TextLink>
                            <TextLink
                                href="/partners/"
                                className="dropdown-item pl-2 pl-lg-4"
                                rel="noreferrer"
                                data-event-category="Page navbar events"
                            >
                                Partners
                            </TextLink>
                        </NavDropdown>
                        {process.env.GATSBY_ENV !== 'production' ? (
                            <Button
                                click={() =>
                                    fetch('/__refresh', { method: 'POST' })
                                        .then(() =>
                                            alert(
                                                'Refresh request sent. Content will refresh in a while.'
                                            )
                                        )
                                        .catch((error) => {
                                            console.error(
                                                'Error refreshing content:',
                                                error
                                            );
                                            alert(
                                                'Failed to send refresh request, check console for details'
                                            );
                                        })
                                }
                            >
                                <Nav.Item>Refresh Content</Nav.Item>
                            </Button>
                        ) : null}
                    </Nav>
                    <Nav className="d-none d-lg-flex">
                        <Nav.Link
                            href="/become-a-partner/"
                            onClick={() => {
                                setIsOpen(false);
                                setVisible(false);
                            }}
                            data-event-tracking
                            data-event-type="click"
                            data-event-category="Page navbar events"
                            data-event-label="Become a partner"
                            data-event-location="nav_top_partner_program"
                        >
                            Become a Partner
                        </Nav.Link>
                        <Nav.Link
                            href="https://calcom.dev.cdwv.pl/team/flotiq/demo"
                            onClick={() => {
                                setIsOpen(false);
                                setVisible(false);
                                if (window.dataLayer) {
                                    window.dataLayer.push({
                                        event: 'lead_generate',
                                    });
                                }
                            }}
                            data-event-tracking
                            data-event-type="click"
                            data-event-category="Page navbar events"
                            data-event-label="Request a demo"
                            data-event-location="nav_top_demo"
                        >
                            Book a Demo
                        </Nav.Link>
                        {!cookies.logged && (
                            <TextLink
                                href={process.env.GATSBY_FLOTIQ_DASHBOARD_URL}
                                className="nav-link"
                                onClick={() => {
                                    setIsOpen(false);
                                    setVisible(false);
                                }}
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_login"
                            >
                                Log in
                            </TextLink>
                        )}
                        {cookies.logged ? (
                            <Button
                                click={() =>
                                    window.open(
                                        process.env.GATSBY_FLOTIQ_DASHBOARD_URL,
                                        '_self'
                                    )
                                }
                                dataEventLabel="My Flotiq"
                            >
                                <Nav.Item>My Flotiq</Nav.Item>
                            </Button>
                        ) : (
                            <Button
                                click={() =>
                                    window.open(
                                        `${process.env.GATSBY_FLOTIQ_DASHBOARD_URL}/register?plan=1ef44daa-fdc3-6790-960e-cb20a0848bfa`,
                                        '_self'
                                    )
                                }
                                dataEventLabel="Try Flotiq for free"
                                dataEventLocation="nav_top_signup"
                            >
                                <Nav.Item>Start for free</Nav.Item>
                            </Button>
                        )}
                    </Nav>
                    <div className="d-lg-none bottom-mobile-nav">
                        <div className="bottom-mobile-nav-bottom-row">
                            <TextLink
                                href="https://calcom.dev.cdwv.pl/team/flotiq/demo"
                                className="dropdown-item"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_demo"
                            >
                                Request a demo
                            </TextLink>
                            <span className="px-3">|</span>
                            <TextLink
                                href="/become-a-partner/"
                                className="dropdown-item"
                                data-event-category="Page navbar events"
                                dataEventLocation="nav_top_partner_program"
                            >
                                Become a Partner
                            </TextLink>
                        </div>
                        {cookies.logged ? (
                            <div className="bottom-mobile-nav-bottom-row">
                                <Button
                                    click={() =>
                                        window.open(
                                            process.env
                                                .GATSBY_FLOTIQ_DASHBOARD_URL,
                                            '_self'
                                        )
                                    }
                                    additionalClasses={['btn-mobile-big']}
                                    dataEventLabel="My Flotiq"
                                >
                                    <Nav.Item>My Flotiq</Nav.Item>
                                </Button>
                            </div>
                        ) : (
                            <div className="d-flex align-items-center pb-4">
                                <div className="bottom-mobile-nav-bottom-row mr-4 p-0">
                                    <TextLink
                                        href={
                                            process.env
                                                .GATSBY_FLOTIQ_DASHBOARD_URL
                                        }
                                        className="dropdown-item"
                                        data-event-category="Page navbar events"
                                        dataEventLocation="nav_top_login"
                                    >
                                        Log in
                                    </TextLink>
                                </div>
                                <div>
                                    <Button
                                        click={() =>
                                            window.open(
                                                `${process.env.GATSBY_FLOTIQ_DASHBOARD_URL}/register?plan=1ef44daa-fdc3-6790-960e-cb20a0848bfa`,
                                                '_self'
                                            )
                                        }
                                        additionalClasses={['btn']}
                                        dataEventLabel="Try Flotiq for free"
                                        dataEventLocation="nav_top_signup"
                                    >
                                        <Nav.Item>Start for free</Nav.Item>
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

const query = graphql`
    query MenuQuery {
        allFeatures {
            nodes {
                id
                name
                order
                menu_icon {
                    localFile {
                        publicURL
                    }
                }
            }
        }
    }
`;

export default CustomNavbar;
